// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question[data-v-a4aac76e]{visibility:hidden;height:0;opacity:0;transform:scale(.9)}.question.active[data-v-a4aac76e]{visibility:visible;opacity:1;height:auto;display:block;transform:scale(1);transition:.3s}.question .previous[data-v-a4aac76e]{font-size:12px;color:#9b59b6;margin-bottom:12px;cursor:pointer}.question .question__label[data-v-a4aac76e]{font-size:22px;font-weight:800;margin-bottom:28px}", ""]);
// Exports
module.exports = exports;
